import { Link } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { SubscriptionType } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import {
  TERMS_AND_CONDITIONS_LINK_MONTHLY,
  TERMS_AND_CONDITIONS_LINK_YEARLY,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

interface Props {
  plan: Plans;
}

export default function PlanBenefitsDescription({ plan }: Props) {
  const { subscription, plans } = useContext(SubscriptionContext);
  if (!plans) return <></>;

  const totalEmails =
    plans[plan].monthly_limit + Number(subscription?.referralsBoost || 0);

  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for VA Plan Clicked");
  };

  const getSettingsPageDescription = () => {
    if (plan === Plans.FREE) {
      return <>✉️ Send {totalEmails} Emails per month</>;
    } else if (plan === Plans.VA || plan === Plans.VA_YEARLY) {
      return (
        <>
          Everything in Pro Plan PLUS:
          <br />
          <br />
          🪄 300 pitches sent on your behalf per month, no manual work needed
          <br />
          {subscription?.ouiStudioData &&
            subscription?.ouiStudioData?.status === SubscriptionType.ACTIVE && (
              <>
                🪄 Access to{" "}
                <Link
                  href="https://www.ouiwestudio.com/ooo"
                  target="_blank"
                  sx={{
                    color: "info.main",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  Oui, We Studio's Out-of-Office Club
                </Link>
                <br />
              </>
            )}
          <br />
          <a
            href={
              plan === Plans.VA
                ? TERMS_AND_CONDITIONS_LINK_MONTHLY
                : TERMS_AND_CONDITIONS_LINK_YEARLY
            }
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackTermsAndCondition}
          >
            Terms & Conditions Apply
          </a>
          {}
        </>
      );
    } else if (plan === Plans.PRO || plan === Plans.PRO_YEARLY) {
      return (
        <>
          ✉️ Send {totalEmails} Emails per month
          <br />
          🔎 Use advanced brand filters to refine your outreach <br />
          ✅ See reply likelihood scores for each contact <br />
          🔄 Get 20 refreshed brand recommendations monthly
        </>
      );
    } else {
      return <></>;
    }
  };

  return <>{getSettingsPageDescription()}</>;
}
